import React, { Component } from "react";
import Slider from "react-slick";


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#96D2CE" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "#96D2CE" }}
      onClick={onClick}
    />
  );
}

export default class CustomArrows extends Component {
  render() {
    const settings = {
      dots:false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };
    return (
      <div>
        <Slider {...settings}>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-1.jpg'}/>
          </div>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-2.jpg'}/>
          </div>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-3.jpg'}/>
          </div>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-4.jpg'}/>
          </div>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-5.jpg'}/>
          </div>
          <div>
          <img src={process.env.PUBLIC_URL+'/images/slider-6.jpg'}/>
          </div>
        </Slider>
      </div>
    );
  }
}